import { STATICS } from 'statics'

export const CONTACT_OPTIONS = {
  SMS: 'SMS',
  EMAIL: 'EMAIL',
}

export const CONTACT_OPTIONS_ICON = {
  [CONTACT_OPTIONS.SMS]: <STATICS.PHONE />,
  [CONTACT_OPTIONS.EMAIL]: <STATICS.ENVELOPE />,
}
